export const theme = {
  //font: "'neue-haas-grotesk-display', sans-serif;",
  font: "'InstrumentSans', sans-serif;",
  color: {
    blue: "#131118", // now black
    black: "#131118",
    green: "#00FF8F",
    oldBlue: "#0064a8",
    lightBlue: "#2487c6",
    midBlue: "#0066A6",
    darkBlue: "#0c436e",
    gray: "#828282", //"#c4ccd7",
    medGray: "#585858",
    darkGray: "#2b2f34",
  },
};

export default theme;
